import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import { selectPickScheduleLayout } from 'services/ui/selectors';

interface OwnProps {
    targetedLayout: string;
    children: React.ReactElement;
}

interface ConnectedProps {
    pickScheduleLayout: ReturnType<typeof selectPickScheduleLayout>;
}

export type Props = OwnProps & ConnectedProps;

export class PickScheduleLayoutGateComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | null {
        const { pickScheduleLayout, targetedLayout, children } = this.props;

        if (pickScheduleLayout === targetedLayout) {
            return children;
        }

        return null;
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    pickScheduleLayout: selectPickScheduleLayout
});

export default connect(mapStateToProps)(PickScheduleLayoutGateComponent);
